import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'app/components/ui/select';
import { PRODUCT_STATUS } from 'utils/constants';
import { useFormContext } from 'react-hook-form';

function ProductStatus() {
  const form = useFormContext();

  return (
    <>
      <div className="bg-white  dark:bg-transparent rounded-md p-4">
        <h3 className="font-medium text-sm mb-2">Status </h3>
        <Select {...form.register('status')} defaultValue="2">
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Active" />
          </SelectTrigger>
          <SelectContent>
            {Object.keys(PRODUCT_STATUS).map(key => (
              <SelectItem key={key} value={key}>
                {PRODUCT_STATUS[key]}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </>
  );
}

export default ProductStatus;
